import * as d3 from 'd3';
import {React, useState, useRef} from 'react';
import { FeatureCollection } from 'geojson';
import routes from './routes.tsx'
import Legend from './Legend.tsx'

type MapProps = {
  width: number;
  height: number;
  data: FeatureCollection;
};

type CensusRow = {
  CT2020: string;
  mean: number; 
  median: number; 
  std: number;

}
  const modeToColor = {
    'WALK': 'grey',
    'BUS' : 'yellow',
    'SUBWAY' : 'green',
    'TRAM' : 'blue'
  }

  const modeToEmoji = {
    'WALK': '🚶',
    'BUS' : '🚌',
    'SUBWAY' : '🚇',
    'TRAM' : '🚊',
    'U OF M MEDICAL CENTER' : '🏥'
  }

  const drawLegs = (route) => {
    if (route) {
      const legs = route.itineraries.legs;
      let totalDist = 0;
      legs.forEach(leg => totalDist = totalDist + (leg.endTime-leg.startTime));
      let startPoint = 720;
      return legs.map((leg, index) => {
        const proportion = 400*(leg.endTime-leg.startTime)/totalDist;

        const minutes = Math.floor((leg.endTime-leg.startTime)/60000);

        const line = <><line
        x1={startPoint}
        x2={startPoint+proportion}
        y1={500}
        y2={500}
        stroke={modeToColor[leg.mode]}
        strokeWidth={3}
      />
      <text x={startPoint}y={index % 2 === 0 ? 490 : 520} fontSize={'small'} fill={'#7B1F58'}>{modeToEmoji[leg.mode]} {minutes} min</text>
      <circle cx={startPoint+proportion} cy={500} r={3} fill='black'></circle>
      <circle cx={startPoint} cy={500} r={3} fill='black'></circle>

      </>

        startPoint=startPoint+proportion;

        return line;

      }
      )

    }
  }

  const drawRoute = (route, projection) => {
    if (route) {
    const legs = route.itineraries.legs;
    return legs.map(leg => {
      const lat1 = leg.from.lat;
      const lon1 = leg.from.lon;
      const lat2 = leg.to.lat;
      const lon2 = leg.to.lon;

      const [x1, y1] = projection([lon1, lat1]);
      const [x2, y2] = projection([lon2, lat2]);
      return<><line
         x1={x1}
         x2={x2}
         y1={y1}
         y2={y2}
         stroke={modeToColor[leg.mode]}
         strokeWidth={3}
       />
       <circle
       cx={x2}
       cy={y2}
       fill={'black'}
       r={3}
       ></circle>
       <circle
       cx={x1}
       cy={y1}
       fill={'black'}
       r={3}
       ></circle>
       <text
       x={(x1+x2)/2}
       y={(y1+y2)/2-10}
       >
        {modeToEmoji[leg.mode]}
        
       </text>
    </> 
    })
  }
    
  }

 const Map = ({ width, height, data }: MapProps) => {
  const [censusData, setCensusData] = useState<CensusRow[]>([])
  const [showRect, setShowRect ] = useState(false);
  const [currTract, setCurrTract] = useState<CensusRow | undefined>(undefined);
  const [mouseClick, setMouseClick] = useState([0,0]);
  const [currRoute, setCurrRoute] = useState<any>(undefined)
  const rectRef = useRef<SVGRectElement | null>(null); // Reference for the rectangle

  d3.csv('/fixed3.csv').then(((d) => {
    setCensusData(d);
  }));

  const justGEOIDS = data.features.map(feature => feature.properties.GEOID);
  console.log(justGEOIDS);

  console.log(data)
  const projection = d3
    .geoMercator()
    .fitSize([width, height], data); 

   const [x, y] = projection.translate();
   projection.translate([x - 400, y + 50]);

  const geoPathGenerator = d3.geoPath().projection(projection);

  
const [hospitalX, hospitalY] = projection([-76.62375, 39.28749 ]);

  const colorScale = d3.scaleLinear<string>()
  .domain([450, 4230]) // Set your min and max data range
  .range(["#EDE2F3", "#7B1F58"]); // The colors for the scale

  //console.log(censusData)
  const allSvgPaths = data.features
    .filter((shape) => shape.id !== 'ATA')
    .map((shape) => {
      const tract = censusData.find(data => data.CT2020 === shape.properties.GEOID);
      const route = routes.data.find(route => route.GEOID.toString() === shape.properties.GEOID);
      if (route){
      console.log(route);
      }
      const median = tract?.median;
      return (
        <path
          key={shape.id}
          d={geoPathGenerator(shape)}
          stroke="white"
          fill= {shape.properties.GEOID === currTract?.CT2020? '#FF7276': colorScale(median)}
          fillOpacity={0.7}
          onMouseOver={(event) => {
            d3.select(event.currentTarget) // Use event.currentTarget to get the hovered element
              .transition()
              .duration(50)
              .attr('opacity', 0.85);
          }}
          onMouseOut={(event) => {
            d3.select(event.currentTarget) // Reset on mouse out
              .transition()
              .duration(50)
              .attr('opacity', 1);
          }}
          onClick={(event) => {
            
          const [x, y] = d3.pointer(event)  
          setMouseClick([x,y]);
          if (currTract?.CT2020 !== shape.properties.GEOID)
          {
          setCurrTract(tract);
          setCurrRoute(route);
          setShowRect(true);
          d3.select(rectRef.current)
            .transition()
            .duration(300) // Duration of the transition
            .attr('opacity', 1);
          }
          else {
            setShowRect(false);
            setCurrRoute(undefined);
            setCurrTract(undefined);
            d3.select(rectRef.current)
            .transition()
            .duration(300) // Duration of the transition
            .attr('opacity', 0); // Set opacity to 1
          }
          

          }
          }

/>)});

  return (
    <div>
      <svg width={width} height={height}>
        {allSvgPaths}
        
        <rect
          ref={rectRef}
          x={700}
          y={350}
          width={500}
          height={200}
          fill="#EDE2F3"
          strokeWidth={0}
          opacity={0}
        />
        {showRect && 
        <>
        <text
        x={710}
        y={380}
        fill='#7B1F58'
        stroke={'#7B1F58'}
        strokeWidth={1}
        >
          Baltimore City: Census Tract No. {currTract?.CT2020}
        </text>
        <text
        x={710}
        y={410}
        fill='#7B1F58'
        > 
          🏥 Median transit time to hospital: ~{Math.floor(currTract?.median/60)} minutes
        </text>
        <text
        x={710}
        y={460}
        fill='#7B1F58'
        > 
           Example route: {currRoute?.itineraries.legs.length -1} transfers
        </text>
        </>
          }
       

        {drawRoute(currRoute, projection)}
        {drawLegs(currRoute)}
        <circle
        cx={hospitalX}
        cy={hospitalY}
        r={20}
        fill='lightBlue'
        fillOpacity={0.5}
        >
        </circle>
        <text
        x={hospitalX-10}
        y={hospitalY+5}
        >
          🏥
        </text>
        <Legend colorScale={colorScale} modeToEmoji={modeToEmoji}/>
      </svg>
    </div>
  );
};

export default Map;